import { render, staticRenderFns } from "./CustomerSegmentationForm.vue?vue&type=template&id=52b16193&"
import script from "./CustomerSegmentationForm.vue?vue&type=script&lang=ts&"
export * from "./CustomerSegmentationForm.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/stylesheets/v2/shared/_combo-field.scss?vue&type=style&index=0&prod&lang=scss&%3B=true&"
import style1 from "@/assets/stylesheets/v2/shared/_checkbox-field.scss?vue&type=style&index=1&prod&lang=scss&%3B=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VContainer,
  VDialog,
  VDivider,
  VFlex,
  VForm,
  VIcon,
  VLayout,
  VSelect,
})
